import { useInvalidateReviews } from '@/entities/review';
import { trpc } from '@/shared/api';

export const useDeleteReview = () => {
  const invalidate = useInvalidateReviews();
  const mutation = trpc.myReviews.delete.useMutation();
  return {
    remove: async (review: { readonly id: string; readonly productId: string }): Promise<void> => {
      await mutation.mutateAsync({ reviewId: review.id });
      await invalidate.afterWrite(review.productId);
    },
    isPending: mutation.isPending,
  };
};
